import './index.less';
import * as React from 'react';
import { Button, Divider, Menu, } from 'antd';
import { Layout } from 'antd';
import { Image } from 'antd';
import { isGranted, L } from '../../lib/abpUtility';
import AppComponentBase from '../AppComponentBase';
import { observer } from 'mobx-react';
import { appRouters } from '../Router/router.config';
import {
  ApiTwoTone, 
  FileTextTwoTone, LeftCircleOutlined,
  LockTwoTone, RightCircleOutlined,
  RightCircleTwoTone, CommentOutlined, AuditOutlined, DashboardOutlined,
  IdcardOutlined, ShopOutlined,  ShoppingCartOutlined, DeploymentUnitOutlined,  AppstoreTwoTone,  
   GroupOutlined, ShoppingOutlined, TeamOutlined, HistoryOutlined ,
} from '@ant-design/icons';

import CondoLogo from './../../images/ftb/team6.png';
import { GetCurrentLoginInformations } from '../../services/session/dto/getCurrentLoginInformations';

const { Sider } = Layout;

export interface ISiderMenuProps {
  loading: boolean;
  path: any;
  collapsed: boolean;
  history: any;
  primaryColor: string;
  secondaryColor: string;
  userImageURL: string;
  currentLoginInfo: GetCurrentLoginInformations;
}

@observer
export class SiderMenu extends AppComponentBase<ISiderMenuProps> {

  state =
    {
      visible: false,
      hideSliderMenu: false,
      windowWidth: 0,
      hideWholeMenu: false,
      iconFontSize: '1.3em'
    }

  async componentDidMount() {


    this.setState({

      windowWidth: window.innerWidth
    });

    if (window.innerWidth <= 800) {
      this.setState({
        hideWholeMenu: true
      });
    }
    else {
      this.setState({
        hideWholeMenu: false
      });
    }



    window.addEventListener('resize', this.handleResize);
    window.addEventListener('scroll', this.handleScroll)
  }

  handleScroll = () => {

  }

  handleResize = () => {


    this.setState({
      windowWidth: window.innerWidth
    });

    if (window.innerWidth <= 800) {
      this.setState({
        hideWholeMenu: true
      });
    }
    else {
      this.setState({
        hideWholeMenu: false
      });
    }

  }


  public render() {
    const { collapsed, history } = this.props;

    return (
      <div>


        {this.props.currentLoginInfo.roles[0] !== "Agency" ?


          this.state.hideWholeMenu === true ? null :
            <div>
              {this.state.hideSliderMenu === false ?
                <div>
                  <Sider style={{ backgroundColor: 'transparent', zIndex: 99, boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 3px 10px 30px 3px rgba(0, 0, 0, 0.19', marginTop: '40%' }}
                    trigger={null} width={320}
                    //hidden={this.state.hideStaticMenu} 
                    hidden={this.state.hideSliderMenu}
                    theme='light'
                    collapsible
                    collapsed={collapsed} >

                    <Menu theme="light" mode="vertical" style={{ textAlign: 'center' }}>
                      <div className="font-face-gm"
                        style={{ marginTop: '5px' }}>
                        <Image src={CondoLogo} preview={false} width={40} />
                      </div>


                      <Divider style={{ marginTop: '8px', marginBottom: '5px' }} />
                      {appRouters
                        .filter((item: any) => !item.isLayout && item.showInMenu)
                        .map((route: any, index: number) => {
                          if (route.permission && !isGranted(route.permission)) return null;

                          return (
                            <Menu.Item key={route.path}
                              onClick={() => history.push(route.path)}>
                              <div>
                                {
                                  route.icon === 'dashboard' ? (<DashboardOutlined style={{ fontSize: this.state.iconFontSize }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />)

                                    : route.icon === 'people' ? (<ShopOutlined style={{ fontSize: this.state.iconFontSize }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />)

                                      : route.icon === 'teams' ? (<DeploymentUnitOutlined style={{ fontSize: this.state.iconFontSize }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />)

                                        : route.icon === 'inventory' ? (<GroupOutlined  style={{ fontSize: this.state.iconFontSize }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />)

                                          : route.icon === 'workOrder' ? (<ShoppingCartOutlined style={{ fontSize: this.state.iconFontSize }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />)

                                            : route.icon === 'scheduling' ? (<TeamOutlined  style={{ fontSize: this.state.iconFontSize }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />)

                                              : route.icon === 'message' ? (<CommentOutlined style={{ fontSize: this.state.iconFontSize }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />)

                                                : route.icon === 'reports' ? (<ShoppingOutlined  style={{ fontSize: this.state.iconFontSize }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />)

                                                  : route.icon === 'integrations' ? (<ApiTwoTone style={{ fontSize: this.state.iconFontSize }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />)

                                                    : route.icon === 'payments' ? (<HistoryOutlined    style={{ fontSize: this.state.iconFontSize }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />)

                                                      : route.icon === 'layout' ? (<AuditOutlined style={{ fontSize: this.state.iconFontSize }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />)

                                                        : route.icon === 'user' ? (<IdcardOutlined style={{ fontSize: this.state.iconFontSize }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />)

                                                          : route.icon === 'role' ? (<LockTwoTone style={{ fontSize: this.state.iconFontSize }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />)

                                                            : route.icon === 'tenant' ? (<AppstoreTwoTone style={{ fontSize: this.state.iconFontSize }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />)

                                                              : route.icon === 'infoHub' ? (<FileTextTwoTone style={{ fontSize: this.state.iconFontSize }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />)

                                                                : <RightCircleTwoTone style={{ fontSize: this.state.iconFontSize }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />}

                              </div>
                              <span>{L(route.title)}</span>
                            </Menu.Item>
                          );
                        })}
                      <br />
                    </Menu>
                  </Sider>

 
                  <div><Button className="font-face-gm" onClick={() => this.setState({ hideSliderMenu: true })}
                    style={{
                      marginTop: '15px', minWidth: '70px', height: '27px', fontSize: '0.8em', marginLeft: '3px',
                      backgroundColor: 'transparent', borderColor: this.props.secondaryColor
                    }} type="default">
                    <LeftCircleOutlined />{L('Hide')} </Button></div>


                </div>
                :
                <div style={{ float: 'left', position: 'fixed', top: 0, left: 2, zIndex: 99, }}>
                  <Button className="font-face-gm" onClick={() => this.setState({ hideSliderMenu: false })}
                    style={{
                      marginTop: '5px', height: '27px', fontSize: '0.8em',
                      backgroundColor: 'transparent', borderColor: this.props.secondaryColor
                    }} type="default">
                    <RightCircleOutlined />{L('Nav')}</Button></div>
              }
            </div>

          : null}
      </div>
    );
  }
}

export default SiderMenu;
